export const COURIER_LIST = 'COURIER_LIST';